import confetti from "canvas-confetti";
import Cookies from "js-cookie";

jQuery(function ($) {
	const base = "gc-popup";
	if (!$(`.${base}`).length) return;

	Cookies.set("popup_seen", "true", { expires: 30 });

	if ($(`.${base}--confetti`).length) {
		confetti({
			particleCount: 200,
			spread: 100,
			origin: { y: 1 },
			zIndex: 9999,
			startVelocity: 100,
			colors: ["#ff6674", "#f2c94c", "#606cb3", "#fff4f5"]
		});
	}

	$(`.${base}__button`).on("click", function () {
		$(`.${base}`).addClass(`${base}--hidden`);
	});
});
